/* istanbul ignore file */
// TODO: find a way to test this
import React, { RefObject } from 'react'

export interface ResizeObserverEntry {
    target: HTMLElement
    contentRect: DOMRectReadOnly
}
export type ObserverCallback = (entry: DOMRectReadOnly) => void

const useResizeObserver = (ref: RefObject<HTMLElement>, callback: ObserverCallback): void => {
    React.useEffect(() => {
        const currentRef = ref.current

        // we need this since ResizeObserver API declaration is missing in typescript: https://github.com/Microsoft/TypeScript/issues/28502
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resizeObserver = new (window as any).ResizeObserver(
            (entries: ResizeObserverEntry[]) => {
                callback(entries[0].contentRect)
            }
        )

        resizeObserver.observe(currentRef)

        return (): void => {
            resizeObserver.unobserve(currentRef)
        }
    }, [ref, callback])
}

export default useResizeObserver
